// extracted by mini-css-extract-plugin
export default {"modalContent":"SuccessReportLostDamagedPalletsBySupplierModal_modalContent__sD3xz"};